import axios from 'axios';
// const BASE_URL = 'http://localhost:3001'; 
const BASE_URL = process.env.REACT_APP_API_BASE || '/prod-api';



const axiosInstance = axios.create({
    baseURL: BASE_URL, // Base URL for all requests
    timeout: 10000, // Optional: Set a timeout for requests (in milliseconds)
    headers: {
        'Content-Type': 'application/json', // Default headers
    },
});

console.log('axiosInstance baseURL:', BASE_URL);
export default axiosInstance;